<ps-legacy-iframe path="manageBuyerSettingsDecipherIframe"></ps-legacy-iframe>
